import React from 'react';
import { Typography } from '@mui/material';
import Dashboard from '@mui/icons-material/Dashboard';

const DashboardPage = () => {
    return (
        <div>
            <Typography variant="h4" gutterBottom>
                Dashboard
            </Typography>
            <Typography variant="body1">
                Welcome to your Basketball Training Dashboard.
            </Typography>
        </div>
    );
};

export default DashboardPage;